import { Select as MantineSelect, type SelectProps } from '@mantine/core';
import { forwardRef, useReducer, useState } from 'react';

/**
 * Mantine's Select with two Mantine 9.1 combobox gaps closed; use it instead of `@mantine/core`'s.
 * aria-controls is refreshed once the listbox mounts (Mantine gives it a new id on every open but
 * renders the input before learning it), and the dropdown closes when focus leaves (a
 * non-searchable Select otherwise stays open over what Tab focuses next). A caller that passes
 * `dropdownOpened` controls it and must close it on blur itself; its dropdown handlers still run.
 */
const Select = forwardRef<HTMLInputElement, SelectProps>(function Select(
    { dropdownOpened, onDropdownOpen, onDropdownClose, onBlur, ...props },
    ref
) {
    const [opened, setOpened] = useState(false);
    const [, rerender] = useReducer((n: number) => n + 1, 0);

    return (
        <MantineSelect
            ref={ref}
            {...props}
            dropdownOpened={dropdownOpened ?? opened}
            onDropdownOpen={() => {
                setOpened(true);
                requestAnimationFrame(rerender);
                onDropdownOpen?.();
            }}
            onDropdownClose={() => {
                setOpened(false);
                onDropdownClose?.();
            }}
            onBlur={(event) => {
                setOpened(false);
                onBlur?.(event);
            }}
        />
    );
});

export default Select;
